import React, { useState } from "react";
import "./App.css";

import TerminalWindow from "./components/TerminalWindow";
import BootAnimationBackdrop from "./components/BootAnimationBackdrop";
import { useEffect } from "react";

const App = () => {
  const [terminalOpen, setTerminalOpen] = useState(true);
  const [showBootAnimation, setShowBootAnimation] = useState(true);

  useEffect(() => {
    console.log("START");
    setTimeout(() => {
      setShowBootAnimation(false);
      console.log("END");
    }, 4000);
  }, []);

  const isMobile = window.matchMedia(
    "(hover: none) and (pointer: coarse)"
  ).matches;

  return (
    <div className="App">
      {showBootAnimation && <BootAnimationBackdrop />}
      {terminalOpen && (
        <TerminalWindow isMobile={isMobile} setTerminalOpen={setTerminalOpen} />
      )}
      <div className="icons-container">
        <div
          id="terminalIcon"
          className="desktop-icon"
          onClick={() => {
            setTerminalOpen(true);
          }}
        />
        <div id="folderIcon" className="desktop-icon" />
        <div id="trashIcon" className="desktop-icon" />
      </div>
    </div>
  );
};

export default App;
